export default "__VITE_ASSET__$unxXek9__"